define(['underscore', 'text!./templates/pa-confirmation.html'],
    (_, templateStr)=> {
        return [function () {
            return {
                restrict: 'A',
                template: templateStr,

                controller: ['$scope', function ($scope) {
                    this._getCoveragesForVehicle = (veh)=> {
                        return veh.coverages.map((vehicleCov)=> {
                            return {name: `${veh.vehicleName} - ${vehicleCov.name}`, amount: vehicleCov.amount};
                        });
                    };

                    this._coverages = function () {
                        const lineCoverages = $scope.chosenQuote.lobs.personalAuto.lineCoverages.map((lineCov)=> {
                            return {name: lineCov.name, amount: lineCov.amount};
                        });
                        const coveragesForVehicles = $scope.chosenQuote.lobs.personalAuto.vehicleCoverages.map(this._getCoveragesForVehicle);

                        return lineCoverages.concat(_.flatten(coveragesForVehicles));
                    };

                    $scope.coverages = this._coverages();
                }]
            };
        }];
    }
);



/** WEBPACK FOOTER **
 ** ./common/js/src/edge/quoteandbind/pa/directives/PAConfirmation.js
 **/